import React, { useEffect, useState } from 'react';
import { IPartnerClientCreated, PartnerService } from '../../services/partner.service';
import './autoparkApiTokens.css';

interface CreateCredentialModalProps {
  isOpen: boolean;
  autoparkId: string;
  onClose: () => void;
  // Called with the created credential (secret included). The caller is responsible for showing the
  // secret exactly once and dropping it afterwards.
  onCreated: (created: IPartnerClientCreated) => void;
}

function CreateCredentialModal({ isOpen, autoparkId, onClose, onCreated }: CreateCredentialModalProps) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setName('');
      setError('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget && !loading) onClose();
  };

  const handleSubmit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) {
      setError('Введите название');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const created = await PartnerService.createClient(autoparkId, trimmed);
      onCreated(created);
    } catch (err: any) {
      setError(err.message || 'Не удалось создать учётные данные');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="api-tokens-modal-overlay" onClick={handleBackdropClick}>
      <form className="api-tokens-modal" onSubmit={handleSubmit}>
        <h2 className="api-tokens-modal__title">Новые учётные данные</h2>
        <p className="api-tokens-modal__hint">
          Название нужно, чтобы отличать интеграции друг от друга — например, по партнёру и окружению.
        </p>
        <label className="api-tokens-field">
          <span className="api-tokens-field__label">Название</span>
          <input
            type="text"
            className={`api-tokens-field__input ${error ? 'api-tokens-field__input--error' : ''}`}
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setError('');
            }}
            placeholder="Агрегатор X, прод"
            maxLength={120}
            autoFocus
            disabled={loading}
          />
          {error && <span className="api-tokens-field__error">{error}</span>}
        </label>
        <div className="api-tokens-modal__actions">
          <button type="submit" className="api-tokens-btn api-tokens-btn--primary" disabled={loading}>
            {loading ? 'Создание...' : 'Создать'}
          </button>
          <button
            type="button"
            className="api-tokens-btn api-tokens-btn--secondary"
            onClick={onClose}
            disabled={loading}
          >
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateCredentialModal;
